module.exports = __webpack_public_path__ + "/fbbefb40231d56a05a53ca419e409712.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/assets/customize_logo.svg
 ** module id = 1267
 ** module chunks = 0
 **/